import { Api } from "../../api/Api";
import { BooleanThunk } from "../IStore";
import { CouponTemplateAssignmentDto, CreateCouponTemplateRequest } from "../models/coupon/CouponManagementDto";
import { thunkCreateErrorNotification, thunkCreateSuccessNotification } from "./NotificationActions";

export const LOAD_ALL_COUPON_TEMPLATES = "LOAD_ALL_COUPON_TEMPLATES";
export const LOAD_COUPON_TEMPLATE_BY_NUMBER = "LOAD_COUPON_TEMPLATE_BY_NUMBER";

export const thunkGetAllCouponTemplates =
  (page: number = 1, size: number = 10, sortBy?: string, sortDirection?: string, statuses?: string[]): BooleanThunk =>
  async (dispatch) => {
    try {
      const response = await Api.getAllCouponTemplates(page, size, sortBy, sortDirection, statuses);
      dispatch({
        type: LOAD_ALL_COUPON_TEMPLATES,
        payload: response,
      });
      return true;
    } catch (e) {
      dispatch(thunkCreateErrorNotification("Failed to load coupon templates", e));
      return false;
    }
  };

export const thunkGetCouponTemplateByNumber =
  (couponTemplateNumber: string): BooleanThunk =>
  async (dispatch) => {
    try {
      const couponTemplate = await Api.getCouponTemplateByNumber(couponTemplateNumber);
      dispatch({
        type: LOAD_COUPON_TEMPLATE_BY_NUMBER,
        payload: couponTemplate,
      });
      return true;
    } catch (e) {
      dispatch(thunkCreateErrorNotification("Failed to load coupon template", e));
      return false;
    }
  };

export const thunkCreateCouponTemplate =
  (couponData: CreateCouponTemplateRequest): BooleanThunk =>
  async (dispatch) => {
    try {
      await Api.createCouponTemplate(couponData);
      dispatch(thunkCreateSuccessNotification("Coupon template created successfully"));
      return true;
    } catch (e) {
      dispatch(thunkCreateErrorNotification("Failed to create coupon template", e));
      return false;
    }
  };

export const thunkActivateCouponTemplate =
  (couponTemplateNumber: string): BooleanThunk =>
  async (dispatch) => {
    try {
      await Api.activateCouponTemplate(couponTemplateNumber);
      dispatch(thunkCreateSuccessNotification("Coupon template activated successfully"));
      return true;
    } catch (e) {
      dispatch(thunkCreateErrorNotification("Failed to activate coupon template", e));
      return false;
    }
  };

export const thunkDeactivateCouponTemplate =
  (couponTemplateNumber: string): BooleanThunk =>
  async (dispatch) => {
    try {
      await Api.deactivateCouponTemplate(couponTemplateNumber);
      dispatch(thunkCreateSuccessNotification("Coupon template deactivated successfully"));
      return true;
    } catch (e) {
      dispatch(thunkCreateErrorNotification("Failed to deactivate coupon template", e));
      return false;
    }
  };

export const thunkDeleteCouponTemplate =
  (couponTemplateNumber: string): BooleanThunk =>
  async (dispatch) => {
    try {
      await Api.deleteCouponTemplate(couponTemplateNumber);
      dispatch(thunkCreateSuccessNotification("Coupon template deleted successfully"));
      return true;
    } catch (e) {
      dispatch(thunkCreateErrorNotification("Failed to delete coupon template", e));
      return false;
    }
  };

export const thunkAssignMembersToCouponTemplate =
  (couponTemplateNumber: string, assignment: CouponTemplateAssignmentDto): BooleanThunk =>
  async (dispatch) => {
    try {
      await Api.assignMembersToCouponTemplate(couponTemplateNumber, assignment);
      dispatch(thunkCreateSuccessNotification("Members assigned to coupon template successfully"));
      return true;
    } catch (e) {
      dispatch(thunkCreateErrorNotification("Failed to assign members to coupon template", e));
      return false;
    }
  };

export const thunkUpdateCouponTemplate =
  (couponTemplateNumber: string, couponData: CreateCouponTemplateRequest): BooleanThunk =>
  async (dispatch) => {
    try {
      await Api.updateCouponTemplate(couponTemplateNumber, couponData);
      dispatch(thunkCreateSuccessNotification("Coupon template updated successfully"));
      return true;
    } catch (e) {
      dispatch(thunkCreateErrorNotification("Failed to update coupon template", e));
      return false;
    }
  };
